import React from 'react';
import styled from 'styled-components';

const sizes = {
  mobileM: '375px',
  mobileL: '425px',
  tablet: '768px',
  desktop: '1800px',
};

export const device = {
  tablet: `(max-width: ${sizes.tablet})`,
  desktop: `(min-width: ${sizes.desktop})`,
};
const Wrapper = styled.div`
  justify-content: center;
  display: flex;
`;
const Container = styled.div`
  margin-top: 100px;
  width: 1140px;
  justify-items: center;
  border-radius: 33px;
  border-width: 2px;
  align-items: center;
  display: flex;
  justify-content: center;
  background: linear-gradient(
    92.23deg,
    rgba(242, 242, 242, 0.36) 1.2%,
    rgba(242, 242, 242, 0.06) 99.77%
  );

  border: 2px solid #0c3f89;
  @media only screen and ${device.tablet} {
    max-width: 345px;
    margin-top: 60px;
  }
`;
const Heading = styled.h2`
  font-family: Inter;
  font-weight: 500;
  font-size: 48px;
      
  text-align: center;
  vertical-align: middle;
  max-width: 840px;
  color: rgba(42, 135, 108, 1);
  @media only screen and ${device.tablet} {
    font-size: 28px;
    max-width: 289px;
    padding-top: 50px;
    padding-bottom: 50px;
  }
`;

const Highlight = styled.span`
  font-family: Inter;
  font-weight: 500;
  font-size: 48px;
      
  text-align: center;
  vertical-align: middle;
  color: rgba(6, 50, 87, 1);
  @media only screen and ${device.tablet} {
    font-size: 28px;
    font-weight: 800;
  }
`;
const InsightsBanner = () => {
  return (
    <Wrapper>
      <Container>
        <Heading>
          Over <Highlight>1 Million </Highlight>insights generated monthly,
          helping brands stay ahead.
        </Heading>{' '}
      </Container>
    </Wrapper>
  );
};

export default InsightsBanner;
